import {type ComponentProps} from 'react';

import AppStoreIcon from '@/assets/icons/app-store-icon.svg?react';
import {APPLE_STORE_LINK} from '@/shared/consts/socialLinks';

export type AppleStoreLinkIconProps = Omit<
  ComponentProps<'a'>,
  'href' | 'children' | 'aria-label'
> & {
  iconProps?: ComponentProps<'svg'>;
};

function AppleStoreLinkIcon({
  className,
  iconProps,
  ...rest
}: AppleStoreLinkIconProps) {
  return (
    <a
      {...rest}
      className={className}
      href={APPLE_STORE_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Apple store"
    >
      <AppStoreIcon {...iconProps} />
    </a>
  );
}

export default AppleStoreLinkIcon;
